import { useEffect, useState } from "react";
import api from "@/lib/api";

let cache = null;
let inflight = null;

/** Canonical government ID types from GET /api/config/id-types — fetched once, cached for the session. */
export function useIdTypes() {
  const [types, setTypes] = useState(cache || []);
  useEffect(() => {
    if (cache) return;
    inflight = inflight || api.get("/config/id-types").then((r) => { cache = r.data; return cache; });
    inflight.then(setTypes).catch(() => setTypes([{ value: "other", label: "Other" }]));
  }, []);
  return types;
}

export const idTypeLabel = (value, types) => value === "government_id" ? "Government ID" : (types || cache || []).find((t) => t.value === value)?.label || (value ? value.replace(/_/g, " ").replace(/\b\w/g, (c) => c.toUpperCase()) : "—");
